export default __webpack_public_path__ + "static/media/e-registro-logo.b1f16ba9.png";